import React from 'react';
import { connect } from 'react-redux';
import Quiz from '../components/Quiztake';
import quizActions from '../actions/quiz';

const QuiztakeContainer = ({
  quizData,
  userdata,
  results,
  step,
  course,
  setQuizStep,
  answerQuestion,
  quizComplete,
  setTimerStartDate,
  startDate,
}) => (
  <Quiz
    quizData={quizData}
    results={results}
    step={step}
    course={course}
    handleQuizStart={setQuizStep}
    handleQuizAnswer={answerQuestion}
    handleQuizComplete={quizComplete}
    handleTimerStartDate={setTimerStartDate}
    startDate={startDate}
    userdata={userdata}
  />
);

const mapStateToProps = state => ({
  quizData: state.quiz.quizData,
  results: state.quiz.results,
  step: state.quiz.step,
  course: state.course,
  startDate: state.quiz.startDate,
  userdata: state.quiz.userdata,
});

const mapDispatchToProps = {
  ...quizActions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuiztakeContainer);
